module.exports = __webpack_public_path__ + "img/smart2.5203c9e2.png";